export default function objToArray(obj: Record<string, any>) {
  return Object.keys(obj).map((key) => ({ mainLock: key, worthValue: obj[key] }));
}
